import { StaticContentSource } from '../content';
import { parseItem } from '../domain';
import { getBuilder } from '../geometry';
import {
  createViewer,
  loadMaterialLibrary,
  setMaterialProvider,
  type ModelResolver,
} from '../render';

// Точка входа. Демо: грузим glTF-модели из каталога + пример rollo → SceneGraph → рендер.
// Реальные модели от конфигуратора придут через postMessage (Фаза 5).
async function boot(): Promise<void> {
  const app = document.querySelector<HTMLDivElement>('#app');
  if (!app) return;

  const canvas = document.createElement('canvas');
  canvas.id = 'viewer';
  app.appendChild(canvas);
  const viewer = createViewer(canvas);

  // glTF-модели по meshId (data-driven; при ошибке — плейсхолдер-геометрия).
  let resolveModel: ModelResolver | undefined;
  try {
    const provider = await new StaticContentSource().loadModels();
    resolveModel = provider.getModel;
  } catch (err) {
    console.warn('[viewer] glTF-модели не загружены, плейсхолдер-боксы:', err);
  }

  // Реальные PBR-текстуры материалов (data-driven; при ошибке — базовые цвета).
  try {
    setMaterialProvider(await loadMaterialLibrary());
  } catch (err) {
    console.warn('[viewer] текстуры материалов не загружены, базовые цвета:', err);
  }

  try {
    const res = await fetch('content/demo-rollo.json');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const item = parseItem(await res.json());
    viewer.setModel(getBuilder(item.model).build(item), resolveModel);
    const controls = document.createElement('div');
    controls.className = 'roll-controls';
    controls.innerHTML = `
      <button type="button" data-target="1">Свернуть</button>
      <button type="button" data-target="0">Развернуть</button>
      <label>Свёрнуто <input type="range" min="0" max="100" value="0" step="0.1" aria-label="Положение шторы"><output>0%</output></label>
      <button type="button" data-action="pause">Пауза</button>`;
    app.appendChild(controls);
    const slider = controls.querySelector<HTMLInputElement>('input')!;
    const output = controls.querySelector('output')!;
    controls.querySelectorAll<HTMLButtonElement>('[data-target]').forEach((button) => {
      button.addEventListener('click', () => viewer.animateRollTo(Number(button.dataset.target)));
    });
    controls.querySelector('[data-action="pause"]')!.addEventListener('click', () => {
      viewer.setRollProgress(viewer.getRollProgress());
    });
    slider.addEventListener('input', () => viewer.setRollProgress(Number(slider.value) / 100));
    const refresh = () => {
      const percent = viewer.getRollProgress() * 100;
      slider.value = String(percent);
      output.textContent = `${Math.round(percent)}%`;
      requestAnimationFrame(refresh);
    };
    refresh();
  } catch (err) {
    console.error('[viewer] не удалось загрузить демо-модель:', err);
  }
}

void boot();
